<template>
  <v-select
      prepend-icon="store"
      :items="getItems"
      :item-text="'branch.name'"
      :item-value="'id'"
      v-model="item"
      :label="$t(label)"
      :loading="loading"
      :error="hasInputErrors('stock')"
      :error-messages="getInputErrors('stock')"
      color="secondary"
      item-color="secondary"
      :rules="required"
  ></v-select>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import StockProvider from "@/modules/delivery/providers/StockProvider";

export default {
  name: "StockCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: [String, Array]
    },
    filteredStock: Object,
    label: {type: String, default: 'delivery.stock.labels.branch'}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    getItems() {
      return this.items.filter(v => v.id != this.filteredStock.id)
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      StockProvider.fetchStock().then(r => {
        this.items = r.data.fetchStock
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

